import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Label, CreateLabelDto } from '../models/label.model';
import { environment } from '../../environments/environment';
import { skipGlobalErrorToastForStatuses } from './error-notification.interceptor';

@Injectable({ providedIn: 'root' })
export class LabelService {
  private readonly base = `${environment.apiBaseUrl}/v1/labels`;
  private readonly appBase = `${environment.apiBaseUrl}/v1/applications`;

  constructor(private http: HttpClient) {}

  getLabels(): Observable<{ items: Label[]; total: number }> {
    return this.http.get<{ items: Label[]; total: number }>(this.base);
  }

  createLabel(dto: CreateLabelDto): Observable<Label> {
    return this.http.post<Label>(this.base, dto);
  }

  deleteLabel(labelId: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${labelId}`);
  }

  assignLabel(applicationId: number, labelId: number): Observable<any> {
    // application-labels.component.ts treats a 409 (already assigned) as a
    // benign idempotent success, not an error - suppress only that status.
    return this.http.post(
      `${this.appBase}/${applicationId}/labels/${labelId}`,
      {},
      { context: skipGlobalErrorToastForStatuses(409) }
    );
  }

  unassignLabel(applicationId: number, labelId: number): Observable<void> {
    return this.http.delete<void>(`${this.appBase}/${applicationId}/labels/${labelId}`);
  }
}
